import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class TipoFuncionariosService {
	constructor(private apiService: ApiService) {}

	post(form): Observable<any> {
		return this.apiService.post('/perfis', form)
	}

	getAll(filtro?): Observable<any> {
		const url = `/perfis`
		return this.apiService.get(url, filtro)
	}

	get(id: string): Observable<any> {
		const url = `/perfis/${id}`
		return this.apiService.get(url)
	}

	put(id: string, form): Observable<any> {
		form._method = 'PUT'
		return this.apiService.post('/perfis/' + id, form)
	}

	delete(id) {
		return this.apiService.delete('/perfis/' + id)
	}

	restore(id): Observable<any> {
		return this.apiService.get('/perfis/reativar/' + id)
	}
}
